// extracted by mini-css-extract-plugin
module.exports = {"blank":"Avatar_blank__3BDxT"};